export * from '@platform/components/loading-bar/loading-bar.component';
